import { gql } from "@apollo/client";

export default gql`
  query getMarketplaceOrders($input: GetMarketplaceOrdersInput){
    getMarketplaceOrders(input: $input){
        success
        data{
            hasNextPage
            totalDocs
            orders{
                _id
                customer
                marketplace
                type
                orderId
                displayOrderId
                orderStatus
                amountPaid
                currency
                checkoutStatus
                taxRate
                isTaxIncluded
                createdTime
                shippingAddress{
                    name
                    street1
                    street2
                    city
                    stateOrProvince
                    postalCode
                    country
                    phone
                    addressId
                }
                shippingService{
                    name
                    cost
                }
                shipmentTracking{
                    shippingCareer
                    trackingNumber
                }
                subTotal
                total
                buyer{
                    userId
                    email
                    firstName
                    lastName
                }
                items{
                    id
                    location
                    site
                    title
                    quantity
                    sku
                }
                paymentStatus
                seller{
                    userId
                }
                cancelStatus
                returnStatus
                refundStatus
                createdAt
                updatedAt
            }
        }
        code
        message
    }
}
`
